module.exports = __webpack_public_path__ + "static/media/worker_manager.a49571f5.svg";